@if (exhibit$ | async; as exhibit) {
  <div id="exhibit-{{exhibit.slug}}" class="bottom-border">
    <ul class="menu">
      <li class="no_border">
        <h1>
          <a [routerLink]="['/', exhibit.category.slug]" [fragment]="exhibit.slug">&#65308; ZURÜCK</a>
        </h1>
      </li>
    </ul>
    <div [id]="exhibit.slug" class="exhibit">
      <img src="{{ exhibit.image.formats.large.url || exhibit.image.url }}" class="img_large">
      <h3>{{ exhibit.title }}</h3>
      <div class="exhibit_content_large_nop">
        <a href="{{ exhibit.image.url}}" target="_blank">BILD GRÖSSER ANZEIGEN</a>
        <p [innerHtml]="exhibit.text"></p>
        <p [innerHtml]="exhibit.moretext"></p>
        @if (exhibit.sold) {
          <p>Verkauft!</p>
        } @else {
          @if (exhibit.minimum_amount) {
            <p>CHF {{exhibit.minimum_amount}}.— exkl. MWST.</p>
          } @else {
            <p>Preis auf Anfrage.</p>
          }
        }
      </div>
      @if (exhibit.auctionEnabled) {
        <app-exhibit-bid id="#exhibit-bid" [exhibit]="exhibit"></app-exhibit-bid>
      }
    </div>
    @if (exhibit.auctionEnabled) {
      @if (account) {
        @if (account) {
          <app-bids-form [exhibit]="exhibit"></app-bids-form>
        }
      } @else {
        <div class="account_item">
          <button routerLink="/login" [queryParams]="{returnUrl:currentUrl}">
            <h2>ANMELDEN</h2>
          </button>
        </div>
      }
    }
  </div>
}